// import { useState } from "react";
// import { TableRow, TableCell, Button, TextField, Grid, Typography } from "@mui/material";
// import { customeStyle } from "utils/style";
// import { useCart } from "utils/CartContext";

// const CartItemNote = ({ itemId, onSave }) => {
  
//   const { couponctx, orderNotesctx, updateCouponctx, saveNotectx } = useCart();
//   const [showTextField, setShowTextField] = useState(false);
//   const [note, setNote] = useState("");
//   const [savedNote, setSavedNote] = useState(""); // State to hold saved note

//   const handleSave = () => {
//     saveNotectx(itemId, note)
//     onSave(itemId, note);      // Call the save function with itemId and note
//     setSavedNote(note);       // Update saved note
//     setShowTextField(false);  // Close the text field
//   };

//   const handleCancel = () => {
//     setNote("");              // Clear text field input
//     setShowTextField(false);  // Close the text field without saving
//   };

//   return (
//     <>
//       <Grid container justifyContent="space-between" sx={{ mt: 1, mb: 1 }} lg={11.5} margin="auto">
//         {/* Display saved note only if it exists */}
//         {savedNote && (
//           <Typography sx={{ fontSize: customeStyle.typography.subhading, mb: 2 }}>
//             {savedNote}
//           </Typography>
//         )}
//       </Grid>

//       {showTextField && (
//         <TableRow>
//           <TableCell colSpan={3}>
//             <TextField
//               fullWidth
//               sx={{
//                 '& .MuiInputBase-root': { fontSize: '1rem', padding: '10px' },
//                 '& .MuiFormLabel-root': { fontSize: '1rem' },
//                 '& .MuiOutlinedInput-root': { minHeight: '30px' }
//               }}
//               label="Enter your note"
//               value={note}
//               onChange={(e) => setNote(e.target.value)}
//               multiline
//               rows={1}
//               size="small"
//             />
//           </TableCell>
//         </TableRow>
//       )}

//       <TableRow>
//         <TableCell colSpan={6}>
//           <Grid  container justifyContent={showTextField?"flex-end":"flex-start"} sx={{ mt: 1, mb: 1 }}  margin="auto">
//             <Button
//               variant="outlined"
//               sx={{ p: 0.3,mr:2, fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
//               size="small"
//               onClick={() => showTextField ? handleCancel() : setShowTextField(true)}
//             >
//               {showTextField ? "Cancel" : "Add Order Note"}
//             </Button>

//             {showTextField && (
//               <Button
//                 sx={{ p: 0.5, fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
//                 variant="contained"
//                 size="small"
//                 onClick={handleSave}
//                 disabled={!note.trim()} // Disable save if note is empty
//               >
//                 Save Note
//               </Button>
//             )}
//           </Grid>
//         </TableCell>
//       </TableRow>
//     </>
//   );
// };

// export default CartItemNote;


import { useState, useEffect } from "react";
import { TableRow, TableCell, Button, TextField, Grid, Typography } from "@mui/material";
import { customeStyle } from "utils/style";
import { useCart } from "utils/CartContext";

const CartItemNote = ({ itemId, onSave }) => {
  const { orderNotesctx, saveNotectx } = useCart();
  const [showTextField, setShowTextField] = useState(false);
  const [note, setNote] = useState("");
  const [savedNote, setSavedNote] = useState("");

  // ✅ Sync note with context when itemId changes
  useEffect(() => {
    const existingNote = orderNotesctx[itemId] || "";
    setNote(existingNote);        // Set note input
    setSavedNote(existingNote);   // Set displayed saved note
  }, [itemId, orderNotesctx]);

  const handleSave = () => {
    saveNotectx(itemId, note);      // Save to context
    onSave(itemId, note);          // Notify parent component
    setSavedNote(note);           // Update saved note state
    setShowTextField(false);      // Hide input field
  };

  const handleCancel = () => {
    setNote(savedNote);           // Revert to saved note
    setShowTextField(false);      // Close input field
  };

  return (
    <>
      <Grid container justifyContent="space-between" sx={{ mt: 1, mb: 1 }} lg={11.5} margin="auto">
      {savedNote && (
  <Typography sx={{ fontSize: customeStyle.typography.subhading, mb: 2 }}>
    {savedNote.order_instruction}  {/* ✅ Access the string inside the object */}
  </Typography>
)}

      </Grid>

      {showTextField && (
        <TableRow>
          <TableCell colSpan={3}>
            <TextField
              variant="standard"
              fullWidth
              label="Enter your note"
              value={note.order_instruction}
              onChange={(e) => setNote(e.target.value)}
              // multiline
              // rows={1}
              size="small"
              sx={{
                '& .MuiInputBase-root': {
                  fontSize: '1rem',
                  padding: '6px 12px', // Adjust padding for better alignment
                  lineHeight: '1.5', // Improve vertical alignment
                },
                '& .MuiFormLabel-root': {
                  fontSize: '1rem',
                  lineHeight: '1.2', // Adjust line height for label positioning
                },
                '& .MuiOutlinedInput-root': {
                  alignItems: 'center', // Ensure vertical alignment without changing height
                },
              }}
            />

          </TableCell>
        </TableRow>
      )}

      <TableRow>
        <TableCell colSpan={6}>
          <Grid container justifyContent={showTextField ? "flex-end" : "flex-start"} sx={{ mt: 1, mb: 1 }} margin="auto">
            <Button
              variant="outlined"
              size="small"
              onClick={() => (showTextField ? handleCancel() : setShowTextField(true))}
              sx={{ p: 0.3, mr: 2, fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
            >
              {showTextField ? "Cancel" : "Add Order Note"}
            </Button>
            {showTextField && (
              <Button
                variant="contained"
                size="small"
                onClick={handleSave}
                disabled={!showTextField}
                sx={{ p: 0.5, fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
              >
                Save Note
              </Button>
            )}
          </Grid>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CartItemNote;
